<style lang="scss">
  @use "@sourcewhale/shared/svelte-design-system/assets/css/design-system/utils";
  @use "@sourcewhale/shared/svelte-design-system/assets/css/design-system/mixins";
  @use "@sourcewhale/shared/svelte-design-system/assets/css/design-system/colors";
  .provider-wrapper {
    display: grid;
    gap: utils.in_rem(12px);
  }
  .section-title {
    @include mixins.h3();
  }
  .toggle-wrapper {
    padding-left: utils.in_rem(12px);
    border-left: 3px solid colors.get(interfaceSwGrey_20);
  }
</style>

<script>
  import SettingDropdown from "../../../../../components/shared/SettingDropdown.svelte";
  import SettingToggle from "../../../../../components/shared/SettingToggle.svelte";
  import {
    activeProviderModalStore,
    integrationStore,
  } from "../../../../../stores";

  export let type;
  export let toggleKeys;
  $: provider = $activeProviderModalStore?.title;

  // Get sync settings
  $: [syncSetting] = $integrationStore.getSettings("sync", type);
  $: syncValue = $integrationStore.getValue(syncSetting.key, type);

  $: allowsNotesAfterSync =
    syncValue === "onInterested" || syncValue === "onReply";

  $: notesSettings = $integrationStore.getSettings("notes", type);

  // Filter toggle settings based on current sync value
  $: toggleSettings = notesSettings.filter(
    (setting) =>
      setting.kind === "checkbox" &&
      (!toggleKeys.length || toggleKeys.includes(setting.key)) &&
      setting.key === "onlyAddNotesAfterSync" &&
      allowsNotesAfterSync
  );
</script>

<div class="provider-wrapper">
  <h3 class="section-title">Adding to {provider}</h3>
  {#if syncSetting}
    <SettingDropdown setting={syncSetting} {type} />
  {/if}
  {#each toggleSettings as setting (setting.key)}
    <div class="toggle-wrapper">
      <SettingToggle {setting} {type} disableTransition={true} />
    </div>
  {/each}
</div>
